import React, { useState, useEffect } from 'react'
import { IoExitOutline } from 'react-icons/io5'
import { toast } from 'react-toastify'
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_HOST } from '../../api_utils'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

function DuplicateLoan(props) {
  const { userDataFromStorage, coloredTheme } = props;
  const [duplicateLoan, setDuplicateLoan] = useState([])
  const [loading, setLoading] = useState(false)

  const getDuplicateLoan = async () => {
    setLoading(true)
    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/loan_header/duplicate_loan`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
        toast.success(data.message)
      } else {
        setLoading(false)
        toast.warn('Duplicate Loan Details Found')
        setDuplicateLoan(data)
      }
    } else {
      setLoading(false)
    }
  }


  useEffect(() => {
    getDuplicateLoan()
  }, [])


  return (
    <div className={userDataFromStorage.user_role === 'admin' ? 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden' : 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden'}>
      <p className='text-gray-800 text-[1.8rem] tracking-wider'>Resolve Duplicate Loan Numbers</p>
      {
        duplicateLoan.length ? '' : <p className='mt-6 text-[0.8rem] text-gray-500'>No Duplicate loan numbers</p>
      }
      <button style={{ backgroundColor: coloredTheme }} className='flex items-center justify-center space-x-2 rounded px-[1rem] py-[0.5rem]  text-white mt-8'>
        <IoExitOutline />
        <p>Exit</p>
      </button>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  )
}

export default DuplicateLoan